import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {ConservationAction as ConservationActionModel} from "../../../Models/StreamBank/ConservationAction";
import {ConservationActionPermit as ConservationActionPermitModel} from "../../../Models/StreamBank/ConservationActionPermit";

import {
    GenericModelViewer,
} from "../../Common/GenericModelViewer";
import {useValidations} from "../../../Hooks/GenericModelHooks";

export const PermitSurveySection = (props) => {
    
    const { 
        OnConservationActionChange,
        EditMode,
        ConservationAction,
        Question,
        SurveyTypeId,
        OnValidation: onValidation,
    } = props;
    
    const [validations, setValidations, isValid] = useValidations();
    
    const conservationActionId = ConservationAction.conservationActionId;
    const permitTypeId = Question.permitTypeId;
    const surveyTypeId = SurveyTypeId;
    const surveyQuestionId = Question.surveyQuestionId;
    const [validationStatusError, setValidationStatusError] = useState(null);
    
    // maybe need to make this not re-create so often?
    const alteredConservationActionPermitModel = useMemo(() => {
        const alteredConservationActionPermitModel = new ConservationActionPermitModel();
        
        alteredConservationActionPermitModel.defaults = {
            conservationActionId,
            Permit: {permitTypeId}
        };

        // hide permitId and show conservationActionId
        alteredConservationActionPermitModel.getFlattenedFieldDefs()
            .find((field) => field.key === "permitId")
            .isHidden = false;

        alteredConservationActionPermitModel.getFlattenedFieldDefs()
            .find( (field) => field.key === "conservationActionId" )
            .isHidden = true;

        return alteredConservationActionPermitModel;
    }, [conservationActionId, permitTypeId]);
    
    const model = useMemo(() => {
        const conservationActionModel = new ConservationActionModel();
        
        const conservationActionPermitsFieldDef = conservationActionModel
            .getFlattenedFieldDefs()
            .find((field) => field.key === "ConservationActionPermits");
        
        conservationActionPermitsFieldDef.customData = {
            permitTypeId,
            surveyTypeId,
        };
        conservationActionPermitsFieldDef.model = alteredConservationActionPermitModel;
        
        return conservationActionModel;
    }, [alteredConservationActionPermitModel, surveyTypeId, permitTypeId])
    
    const updateValidation = useCallback(
        (validation, editorGuid) => {
            // const { SurveyFormInput } = props;
            let valid = true;
            
            setValidations(validation);
            Object.keys(validation).forEach((x) => {
                const result = validation[x];
                
                if(result) {
                    valid &= result.valid;
                }
            });
            
            if(valid) {
                setValidationStatusError(null);
            } else {
                setValidationStatusError("This section must be completed.");
            }
        }
    , [setValidations]);
    
    useEffect(() => {
        onValidation?.(surveyQuestionId, validationStatusError);
        return () => {
            onValidation?.(surveyQuestionId, null);
        }
    }, [surveyQuestionId, onValidation, validationStatusError])
    
    const hiddenGroups = model?.getFieldDefGroups?.()?.filter((group) => group.key !== "Permits").map((x) => x.key);

    return <GenericModelViewer
        Model={model}
        IsNewModel={false}
        EditMode={EditMode}
        HideGroups={hiddenGroups}
        Data={ConservationAction}
        Update={OnConservationActionChange}
        OnValidationUpdate={updateValidation}
    />;
}


